module.exports = __webpack_public_path__ + "static/media/icon-2.d2c111f9.svg";